import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
    helpWrapper: {
        margin: 'auto',
        maxWidth: '1017px',
        marginBottom: '60px',
        position: 'relative',
        marginTop: '2rem',

        '@media (min-width: 500px) and (max-width:599px)': {
            maxWidth: '570px',
            paddingLeft: '30px',
            paddingRight: '30px',
        },

        '@media (min-width: 600px) and (max-width:1019px)': {
            maxWidth: '694px',
            paddingLeft: '30px',
            paddingRight: '30px',
            marginBottom: '51px',
        },
        '@media (min-width: 0px) and (max-width:499px)': {
            maxWidth: '344px',
        },

        '@media (min-width: 1020px) and (max-width:1199px)': {
            maxWidth: '995px',
            margin: 'auto',
            marginTop: '20px',
            paddingLeft: '30px',
            marginBottom: '40px',
            paddingRight: '30px',
        },
        '@media (min-width: 1920px)': {
            maxWidth: '1076px',
            marginTop: '4.5rem',
        },
    },
}));

export default styles;
